import { render, staticRenderFns } from "./ReportFormDescriptionRequired.vue?vue&type=template&id=01f6a8d0"
import script from "./ReportFormDescriptionRequired.vue?vue&type=script&lang=ts"
export * from "./ReportFormDescriptionRequired.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports